{
  "recording-type": "Recording Type",
  "mortgage-amount": "Amount",
  "tax-criteria": "Tax Criteria",
  "sales-tax-rate": "Sales Tax Rate"
}
